import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadMySubscriptionsSuccessAction, mySubscriptionsActionTypes} from '../actions/my-subscriptions';
import {SubscriptionI} from '../models/subscription-i';

export interface MySubscriptionsState {
  array: SubscriptionI[];
}

const initialState: MySubscriptionsState = {
  array: []
};

export function mySubscriptionsReducer(state: MySubscriptionsState = initialState, action: Action): MySubscriptionsState {
  switch (action.type) {
    case mySubscriptionsActionTypes.LOAD:
      return handleLoadAction();
    case mySubscriptionsActionTypes.LOAD_SUCCESS:
      return handleLoadSuccess(state, action);
    case mySubscriptionsActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadAction(): MySubscriptionsState {
  return initialState;
}

function handleLoadSuccess(state: MySubscriptionsState, action: LoadMySubscriptionsSuccessAction): MySubscriptionsState {
  const newState = _.clone(state);
  newState.array = action.payload || [];
  return newState;
}

function handleLoadFailAction(state: MySubscriptionsState): MySubscriptionsState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const mySubscriptionsSelectors = {
  array: (state: MySubscriptionsState) => _.get(state, 'array', [])
};
